import store from '@/store'

export default {
  setUsers(state, value) {
    state.users = value
  },
  setSelectedUser(state, payload) {
    store.getters.newBookings[payload.currentTab].selectedUser = payload.data
  },
  addUserToUsers(state, payload) {
    state.users.push(payload.user)
  },
  setNullUsers(state) {
    state.users = []
  },
}
